"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _backgroundImage = require("../images/background-image");

var _styledTools = require("styled-tools");

var _responsive = require("../../styles/responsive");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n      opacity: 0;\n      visibility: hidden;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n    opacity: 0;\n    visibility: hidden;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * `Wrapper` styled component.
 */


var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "video__Wrapper",
  componentId: "sc-3ax11m-0"
})(["left:0;min-height:100%;overflow:hidden;position:absolute;top:50%;transform:translate(0,-50%);width:100%;&::before{content:'';display:block;height:0;padding-bottom:56.25%;}"]);
/**
 * `StyledBackgroundImage` styled component.
 */


var StyledBackgroundImage = (0, _styledComponents.default)(_backgroundImage.BackgroundImage).withConfig({
  displayName: "video__StyledBackgroundImage",
  componentId: "sc-3ax11m-1"
})(["", ""], _responsive.media.min('md')(_templateObject()));
/**
 * `StyledVideo` styled component.
 */

var StyledVideo = _styledComponents.default.video.withConfig({
  displayName: "video__StyledVideo",
  componentId: "sc-3ax11m-2"
})(["height:100%;left:50%;position:absolute;top:0;transform:translate(-50%,0);width:auto;", ""], (0, _styledTools.ifProp)('shouldHide', (0, _styledComponents.css)(["", ""], _responsive.media.max('md')(_templateObject2()))));
/**
 * Render video sources.
 */


var renderVideoSources = function renderVideoSources(sources) {
  return (0, _map2.default)(sources, function (value, key) {
    return _react.default.createElement("source", {
      key: key,
      src: value,
      type: "video/".concat(key)
    });
  });
};
/**
 * Export `Video` component.
 */


var Video = function Video(_ref) {
  var image = _ref.image,
      sources = _ref.sources,
      rest = _objectWithoutProperties(_ref, ["image", "sources"]);

  return _react.default.createElement(Wrapper, null, !(0, _isEmpty2.default)(image) && _react.default.createElement(StyledBackgroundImage, image), _react.default.createElement(StyledVideo, _extends({
    shouldHide: (0, _isEmpty2.default)(image)
  }, rest), renderVideoSources(sources)));
};

exports.Video = Video;